var React = require('react');

function Deaf (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M508.48 31.8L480.2 3.51a12 12 0 0 0-17 0l-87 87a12 12 0 0 0 0 17l28.28 28.29a12 12 0 0 0 17 0l87-87a12 12 0 0 0 0-17zM169 314.74a12 12 0 0 0-17 0L3.51 463.23a12 12 0 0 0 0 17l28.29 28.25a12 12 0 0 0 17 0L197.26 360a12 12 0 0 0 0-17z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M240 84c-97 0-176 79-176 176a28 28 0 0 0 56 0 120 120 0 0 1 240 0c0 75.16-71 70.31-72 143.62v.38a52.06 52.06 0 0 1-52 52 28 28 0 0 0 0 56 108.13 108.13 0 0 0 108-107.77c.59-34.43 72-48.23 72-144.23 0-97-78.95-176-176-176zm0 152a24 24 0 0 1 24 24 28 28 0 0 0 56 0 80 80 0 0 0-160 0 28 28 0 0 0 56 0 24 24 0 0 1 24-24z","className":"fa-primary","key":2})]);
}

Deaf.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Deaf;

Deaf.default = Deaf;
